module.exports = __webpack_public_path__ + "static/img/banner-bg.5759a41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/banner-bg.jpg
// module id = PX7L
// module chunks = 0